/**
 * Development-only logging utilities
 *
 * Controlled by:
 * - `NEXT_PUBLIC_ENABLE_DEV_LOG=true` — works in browser + server (inlined at build)
 * - `ENABLE_DEV_LOG=true` — server-only runtime flag (no rebuild needed on Vercel)
 *
 * Set in `.env.local` for local dev, or in deployment env for staging/debug builds.
 */

export function isDevLoggingEnabled(): boolean {
  return process.env.NEXT_PUBLIC_ENABLE_DEV_LOG === 'true' || process.env.ENABLE_DEV_LOG === 'true';
}

/**
 * Log messages only when dev logging is enabled
 */
export function devLog(...args: unknown[]): void {
  if (isDevLoggingEnabled()) {
    console.log(...args);
  }
}

/**
 * Log errors only when dev logging is enabled
 */
export function devError(...args: unknown[]): void {
  if (isDevLoggingEnabled()) {
    console.error(...args);
  }
}

/**
 * Log warnings only when dev logging is enabled
 */
export function devWarn(...args: unknown[]): void {
  if (isDevLoggingEnabled()) {
    console.warn(...args);
  }
}
